import React from 'react';
import PropTypes from 'prop-types';
import { Typo } from 'uikit/content';
import { intlFormat } from 'date-fns';

import styles from '../styles/videoAgendaSection.module.scss';
import VideoAgendaSectionItem from './videoAgendaSectionItem';

/* eslint-disable camelcase */
const VideoAgendaSection = ({
  agendaItems = [],
  eventEndAt,
  eventStartAt,
  isEnrolled = false,
  selectedAgendaItem,
  viewAgendaItem,
}) => {
  const { start_date, start_time } = agendaItems[0];
  // agenda items always returned as UTC
  const date = new Date(`${start_date}T${start_time}Z`);
  const formattedDate = intlFormat(
    new Date(date),
    {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
    },
    { locale: document.documentElement.lang || 'en' },
  );

  return (
    <div className={styles.container}>
      <Typo element="h4" variant="d02" modifier="bold" className={styles.date}>
        {formattedDate}
      </Typo>
      {agendaItems.map((item) => (
        <VideoAgendaSectionItem
          key={item.id}
          isEnrolled={isEnrolled}
          item={item}
          selectedAgendaItem={selectedAgendaItem}
          viewAgendaItem={viewAgendaItem}
          eventStartAt={eventStartAt}
          eventEndAt={eventEndAt}
        />
      ))}
    </div>
  );
};

VideoAgendaSection.propTypes = {
  agendaItems: PropTypes.arrayOf(PropTypes.shape({})),
  isEnrolled: PropTypes.bool,
};

export default React.memo(VideoAgendaSection);
